module.exports = __webpack_public_path__ + "static/media/ilbc1.ccea6d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc1.jpg
// module id = 188
// module chunks = 0